/**
 * Centralized constants for legal pages.
 *
 * Marketplace-agnostic posture: CardSimp is a Platform / Venue operated by
 * AuraKit LLC. Independent Sellers list and fulfill items. The Platform is
 * itself permitted to act as a Seller on individual listings — that mechanism
 * is what lets the operator sell solo today without changing this copy the
 * day a second Seller joins.
 */

export const LEGAL_DATES = {
	privacy: 'July 23, 2026',
	terms: 'July 23, 2026',
	disclaimer: 'July 23, 2026',
	safety: 'July 23, 2026'
} as const;

export const LEGAL_REVIEW_DATES = {
	privacy: 'July 23, 2026',
	terms: 'July 23, 2026',
	disclaimer: 'July 23, 2026',
	safety: 'July 23, 2026'
} as const;

// Bump on any material Terms change so active sellers re-accept
// per legal/terms-acceptance-flow-v4-hybrid.
export const TERMS_VERSION = '2026.07.23' as const;

export const CONTACT_EMAIL = 'support@cardsimp.com' as const;

/** Platform operator name (AuraKit LLC dba CardSimp). */
export const OPERATOR_NAME = 'CardSimp' as const;

/**
 * Threshold (in cents) above which a listing is considered "high value"
 * and triggers safety nudges in the listing form and on the public item page.
 */
export const HIGH_VALUE_LISTING_CENTS = 50000; // $500
